export function getFactValueScale(value: string) {
  const characterCount = [...value.trim()].length;

  if (characterCount <= 8) return "short";
  if (characterCount <= 40) return "medium";
  return "long";
}
